import { render, staticRenderFns } from "./SendCustomersSms.vue?vue&type=template&id=d1c18fa4"
import script from "./SendCustomersSms.vue?vue&type=script&lang=js"
export * from "./SendCustomersSms.vue?vue&type=script&lang=js"
import style0 from "./SendCustomersSms.vue?vue&type=style&index=0&id=d1c18fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports